import { subscribe, publish } from '@/utils/event-bus';
(window as any).subscribe = subscribe;
(window as any).publish = publish;
